import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';

interface TypeLegend {
  label: string;
  description: string;
  cssClass: 'aluguel' | 'aula' | 'fixo' | 'available' | 'pending' | 'blocked' | 'finalizado';
}

interface AttendeeLegend {
  label: string;
  description: string;
  cssClass: 'paid' | 'pending' | 'rejected' | 'local' | 'empty';
}

import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';

@Component({
  selector: 'lessor-agenda-legend-modal',
  templateUrl: './agenda-legend-modal.component.html',
  styleUrls: ['./agenda-legend-modal.component.scss'],
  imports: [IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonTitle, IonToolbar],
})
export class AgendaLegendModalComponent {
  private readonly modalCtrl = inject(ModalController);

  /** Cores dos cards por tipo de slot. Reflete exatamente o SCSS do
   *  calendar-court-event (`.type-*`). Se mudar a paleta lá, atualizar aqui. */
  readonly typeLegends: TypeLegend[] = [
    {
      label: 'Disponível',
      description: 'Slot vazio. Toque para criar uma reserva ou bloqueio.',
      cssClass: 'available',
    },
    {
      label: 'Aluguel',
      description:
        'Slot reservado — pode ser uso individual ou compartilhado entre atletas. Cor fria (transacional).',
      cssClass: 'aluguel',
    },
    {
      label: 'Aula',
      description:
        'Slot com professor/turma. Cor quente (rosa) — segue padrão dos apps fitness (Mindbody, ClassPass).',
      cssClass: 'aula',
    },
    {
      label: 'Mensalista',
      description:
        'Horário fixo de turma recorrente (ex: toda terça 19h). Verde signaliza recorrência permanente.',
      cssClass: 'fixo',
    },
    {
      label: 'Aguardando aprovação',
      description: 'Reserva criada pelo cliente esperando sua aprovação.',
      cssClass: 'pending',
    },
    {
      label: 'Bloqueado',
      description: 'Slot indisponível por bloqueio manual (almoço, manutenção, evento).',
      cssClass: 'blocked',
    },
    {
      label: 'Finalizado',
      description:
        'Horário que já passou. Cor do tipo original desbotada — você ainda vê o que aconteceu.',
      cssClass: 'finalizado',
    },
  ];

  /** Estados das pílulas dos atletas inscritos. */
  readonly attendeeLegends: AttendeeLegend[] = [
    {
      label: 'Pago',
      description: 'Pagamento online aprovado e confirmado.',
      cssClass: 'paid',
    },
    {
      label: 'Pendente',
      description: 'Aguardando pagamento ou aprovação manual.',
      cssClass: 'pending',
    },
    {
      label: 'Reprovado',
      description: 'Pagamento foi recusado pela operadora.',
      cssClass: 'rejected',
    },
    {
      label: 'Local',
      description: 'Vai pagar no balcão do centro esportivo.',
      cssClass: 'local',
    },
    {
      label: 'Vaga aberta',
      description: 'Posição livre no slot — espera novo atleta.',
      cssClass: 'empty',
    },
  ];

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
